import "@arco-design/web-react/es/Space/style";
import _Space from "@arco-design/web-react/es/Space";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import "@arco-design/web-react/es/Checkbox/style";
import _Checkbox from "@arco-design/web-react/es/Checkbox";
import _IconLock from "@arco-design/web-react/icon/react-icon/IconLock";
import "@arco-design/web-react/es/Form/style";
import _Form from "@arco-design/web-react/es/Form";
import "@arco-design/web-react/es/Input/style";
import _Input from "@arco-design/web-react/es/Input";
import _IconUser from "@arco-design/web-react/icon/react-icon/IconUser";
import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import useStorage from '@/utils/useStorage';
import useLocale from '@/utils/useLocale';
import locale from './locale';
import styles from './style/index.module.less';
import md5 from 'md5';
import constant from '@/utils/constant';
import qs from 'query-string';
import OemLogo from '@/components/OemLogo';
export default function LoginForm() {
  //captcha
  let captcha;
  const formRef = useRef();
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [loginParams, setLoginParams, removeLoginParams] = useStorage('loginParams');
  const t = useLocale(locale);
  const [rememberPassword, setRememberPassword] = useState(!!loginParams);

  function afterLoginSuccess(params) {
    // 记住密码
    if (rememberPassword) {
      setLoginParams(JSON.stringify(params));
    } else {
      removeLoginParams();
    } // 记录登录状态


    localStorage.setItem('userStatus', 'login'); // 跳转首页

    window.location.href = '/';
  }

  function login(params, captcha) {
    setErrorMessage('');
    setLoading(true);
    const postValues = JSON.parse(JSON.stringify(params));
    postValues.password = md5(postValues.password);
    axios.post('/tp/user/login', qs.stringify({ ...postValues,
      captcha
    })).then(res => {
      const {
        code,
        msg
      } = res.data;

      if (code === constant.SysSuc) {
        afterLoginSuccess(params);
      } else {
        setErrorMessage(msg || t['login.form.login.errMsg']);
      }
    }).finally(() => {
      setLoading(false);
    });
  } // 读取 localStorage，设置初始值


  useEffect(() => {
    const rememberPassword = !!loginParams;
    setRememberPassword(rememberPassword);

    if (formRef.current && rememberPassword) {
      const parseParams = JSON.parse(loginParams);
      formRef.current.setFieldsValue(parseParams);
    }
  }, [loginParams]); // 嵌入式
  // 绑定验证码实例函数。该函数为固定写法，无需修改

  function getInstance(instance) {
    captcha = instance;
  }

  async function captchaVerifyCallback(captchaVerifyParam) {
    // 1.向后端发起业务请求，获取验证码验证结果和业务结果
    // const result = await xxxx('http://您的业务请求地址', {
    //   captchaVerifyParam: captchaVerifyParam, // 验证码参数
    // });
    formRef.current.validate().then(values => {
      login(values, captchaVerifyParam);
    });
  } // 业务请求结果回调函数


  function onBizResultCallback(bizResult) {
    if (bizResult === true) {
      // 如果业务验证通过，跳转到对应页面。此处以跳转到https://www.aliyun.com/页面为例
      window.location.href = 'https://www.aliyun.com/';
    } else {
      // 如果业务验证不通过，给出不通过提示。此处不通过提示为业务验证不通过！
      alert('业务验证不通过！');
    }
  }

  function onSubmitClick() {
    formRef.current.validate().then(values => {
      // login(values);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      initAliyunCaptcha({
        SceneId: 'ile6nr4e',
        // 场景ID。通过步骤一添加验证场景后，您可以在验证码场景列表，获取该场景的场景ID
        prefix: 'sb9g1r',
        // 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
        mode: 'embed',
        // 验证码模式。embed表示要集成的验证码模式为嵌入式。无需修改
        element: '#captcha-element',
        // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
        button: '#login_btn',
        // 触发业务请求的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
        captchaVerifyCallback: captchaVerifyCallback,
        // 业务请求(带验证码校验)回调函数，无需修改
        onBizResultCallback: onBizResultCallback,
        // 业务请求结果回调函数，无需修改
        getInstance: getInstance,
        // 绑定验证码实例函数，无需修改
        slideStyle: {
          width: 320,
          height: 40
        },
        // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
        language: 'cn',
        // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
        immediate: true,
        // 完成验证后，是否立即发送验证请求（调用captchaVerifyCallback函数）
        region: 'cn' //验证码示例所属地区，支持中国内地（cn）、新加坡（sgp）

      });
    });
  } // useEffect(()=>{
  //
  // }, [])


  return /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-title']
  }, /*#__PURE__*/React.createElement(OemLogo, null)), /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-sub-title']
  }, t['login.form.title']), /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-error-msg']
  }, errorMessage), /*#__PURE__*/React.createElement(_Form, {
    className: styles['login-form'],
    layout: "vertical",
    ref: formRef
  }, /*#__PURE__*/React.createElement(_Form.Item, {
    field: "account",
    rules: [{
      required: true,
      message: t['login.form.userName.errMsg']
    }]
  }, /*#__PURE__*/React.createElement(_Input, {
    prefix: /*#__PURE__*/React.createElement(_IconUser, null),
    placeholder: t['login.form.userName.placeholder'],
    onPressEnter: onSubmitClick
  })), /*#__PURE__*/React.createElement(_Form.Item, {
    field: "password",
    rules: [{
      required: true,
      message: t['login.form.password.errMsg']
    }]
  }, /*#__PURE__*/React.createElement(_Input.Password, {
    prefix: /*#__PURE__*/React.createElement(_IconLock, null),
    placeholder: t['login.form.password.placeholder'],
    onPressEnter: onSubmitClick
  })), /*#__PURE__*/React.createElement("div", {
    id: "captcha-element"
  }), /*#__PURE__*/React.createElement(_Space, {
    size: 16,
    direction: "vertical"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-password-actions']
  }, /*#__PURE__*/React.createElement(_Checkbox, {
    checked: rememberPassword,
    onChange: setRememberPassword
  }, t['login.form.rememberPassword'])), /*#__PURE__*/React.createElement(_Button, {
    id: "login_btn",
    type: "primary",
    long: true,
    onClick: onSubmitClick,
    loading: loading
  }, t['login.form.login']))));
}